// Path calculation utility functions


export const calculateDistance = (point1, point2) => {
  // Convert degree differences to approximate kilometers
  const latDiff = Math.abs(point2.latitude - point1.latitude);
  const lonDiff = Math.abs(point2.longitude - point1.longitude);
  
  // Convert to kilometers using degree-to-km conversion
  const latKm = latDiff * 111.0;
  const lonKm = lonDiff * 111.0;
  
  // Manhattan distance in kilometers
  return latKm + lonKm;
};


export const calculatePathDistance = (pathIds, locations) => {
  if (!pathIds || pathIds.length < 2 || !locations || locations.length === 0) {
    return 0;
  }
  
  let totalDistance = 0;
  const locationMap = new Map(locations.map(loc => [loc.id, loc]));
  
  for (let i = 0; i < pathIds.length - 1; i++) {
    const fromLoc = locationMap.get(pathIds[i]);
    const toLoc = locationMap.get(pathIds[i + 1]);
    
    if (fromLoc && toLoc) {
      totalDistance += calculateDistance(
        { latitude: fromLoc.latitude, longitude: fromLoc.longitude },
        { latitude: toLoc.latitude, longitude: toLoc.longitude }
      );
    }
  }
  
  return totalDistance;
};

export const calculateDistancesList = (locations, currentPointId, visitedPointIds, nextPointId) => {
  const currentPoint = locations.find(loc => loc.id === currentPointId);
  if (!currentPoint) return [];
  
  // Create a set of visited points for quick lookup
  const visitedSet = new Set(visitedPointIds);
  
  // Calculate distances to all other points
  return locations
    .filter(loc => loc.id !== currentPointId) // Exclude current point
    .map(loc => {
      const distance = calculateDistance(
        { latitude: currentPoint.latitude, longitude: currentPoint.longitude },
        { latitude: loc.latitude, longitude: loc.longitude }
      );
      
      return {
        pointId: loc.id,
        pointName: loc.name,
        distance: distance,
        visited: visitedSet.has(loc.id),
        isNext: loc.id === nextPointId
      };
    })
    .sort((a, b) => a.distance - b.distance); // Sort by distance (ascending)
}; 